<template>
  <footer class="l-footer">
    <ul class="l-footer-nav">
      <li class="l-footer-nav__item">
        <a :href="appUrl" class="l-footer-nav__link">
          <div class="l-footer-nav__inner">
            <i class="fas fa-home fa-lg"></i>
            <span class="l-footer-nav__label">ダッシュボード</span>
          </div>
        </a>
      </li>
      <li class="l-footer-nav__item">
        <Anchor
          :to="{ name: 'room', query: { r: role.query } }"
          class="l-footer-nav__link"
        >
          <div class="l-footer-nav__inner">
            <i class="fas fa-comment-dots fa-lg"></i>
            <Badge v-if="roomCountUnread" variant="count">
              {{ roomCountUnread | roundNumberText(100) }}
            </Badge>
            <span class="l-footer-nav__label">チャット</span>
          </div>
        </Anchor>
      </li>
      <li class="l-footer-nav__item">
        <Anchor :href="profileUrl" target="_blank" class="l-footer-nav__link">
          <div class="l-footer-nav__inner">
            <i class="fas fa-user fa-lg"></i>
            <span class="l-footer-nav__label">マイページ</span>
          </div>
        </Anchor>
      </li>
    </ul>
    <div class="informations" ref="footerInfoHeight">
      <div class="l-inner">
        <ul>
          <li>
            <a :href="faqUrl" target="_blank">
              よくあるご質問
            </a>
          </li>
          <li>
            <a :href="inquiryUrl" target="_blank">
              お問い合わせ
            </a>
          </li>
          <li>
            <a :href="termsUrl" target="_blank">
              利用規約
            </a>
          </li>
          <li>
            <a :href="privacypolicyUrl" target="_blank">
              プライバシーポリシー
            </a>
          </li>
          <li>
            <a :href="corporateUrl" target="_blank">
              運営会社情報
            </a>
          </li>
        </ul>
        <p class="l-footer__copy">Copyright © PLAN-B Inc.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import Anchor from '@/components/Anchor';
import Badge from '@/components/Badge';

export default {
  components: {
    Anchor,
    Badge
  },
  mounted() {
    // scroll位置の取得
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  },
  computed: {
    oldRoom() {
      return this.$store.getters.oldRoom;
    },
    profileUrl() {
      return this.$constants.profileUrl[this.role.name];
    },
    appUrl() {
      return this.$constants.appUrl[this.role.name];
    },
    faqUrl() {
      return this.$constants.faqUrl[this.role.name];
    },
    inquiryUrl() {
      return this.$constants.inquiryUrl[this.role.name];
    },
    termsUrl() {
      return this.$constants.termsUrl[this.role.name];
    },
    privacypolicyUrl() {
      return this.$constants.privacypolicyUrl[this.role.name];
    },
    corporateUrl() {
      return this.$constants.corporateUrl;
    },
    role() {
      return this.$store.state.role;
    },
    room() {
      let room = null;
      if (this.oldRoom) {
        room = this.oldRoom;
      } else if (this.rooms.length) {
        room = this.rooms[0];
      }
      return room;
    },
    rooms() {
      return this.$store.state.rooms;
    },
    roomCountUnread() {
      return this.room ? this.room.countUnread : 0;
    }
  }
};
</script>
